import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/customer.owners.query.gql"
import type { CustomerOwnersQuery } from "@/v2-backoffice-client/customer/__types__/customer.owners.query"

export function useCustomerOwnersQuery() {
  return useQuery<CustomerOwnersQuery>(query)
}
